module.exports = __webpack_public_path__ + "img/ic24Delete.13520b9b.svg";